import { STATUS } from '@/constants';
import { create } from 'zustand';

const initialState = {
  toasts: [
    // {
    //   id: '1',
    //   message: 'This is a test toast',
    //   type: STATUS.SUCCESS,
    //   display: 'show',
    // },
  ],
};

const useToastStore = create((set) => ({
  ...initialState,

  addToast: (toast) => {
    const existingToast = useToastStore.getState().toasts.some((t) => t.message === toast.message);
    if (existingToast) return;

    const toastWithId = {
      ...toast,
      display: 'show',
      id: toast.id || Date.now().toString(),
      state: toast.type === STATUS.SUCCESS ? 'positive' : (toast.type === STATUS.FAILURE || toast.type === STATUS.ERROR) ? 'negative' : toast.type === STATUS.WARNING ? 'alert' : undefined,
    };

    set(() => ({
      toasts: [toastWithId],
    }));

    const hideToast = () => {
      set((state) => ({
        toasts: state.toasts.map((t) => (t.id === toastWithId.id ? { ...t, display: 'hide' } : t)),
      }));

      setTimeout(() => {
        set((state) => ({
          toasts: state.toasts.filter((t) => t.id !== toastWithId.id),
        }));
      }, 5 * 1000); // Remove after additional 5 seconds
    };

    setTimeout(hideToast, toast.duration || 2.5 * 1000); // Default duration to 2.5 seconds
  },

  removeToast: (toastId) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== toastId),
    })),

  updateToast: (toastId, updatedToast) =>
    set((state) => ({
      toasts: state.toasts.map((t) => (t.id === toastId ? { ...t, ...updatedToast } : t)),
    })),
  reset: () => set({ ...initialState })
}));

export default useToastStore;
